<template>
  <div class="current-product-wrapper">
    <span class="no-product" v-if="noCurrentProduct">Team does not have default product
      <b-button @click="toggleEditing">Choose Product</b-button>
    </span>
    <div class="has-product" v-else>
      <TeamProductForm v-if="editing"/>
      <dl v-else>
        <dt>Paper:</dt><dd>{{productTemplateAttrs.paper}}</dd>
        <dt>Corners:</dt><dd>{{productTemplateAttrs.corners}}</dd>
        <dt>Default Qty:</dt><dd>{{productTemplate.default_qty}}</dd>
      </dl>
      <span v-if="editButton" @click="toggleEditing" class="edit-product" v-html="editIcon()"/>
    </div>
  </div>
</template>

<style scoped lang="scss">
.current-product-wrapper {
  margin: 1em 0 0 0;
  @media (min-width: 576px) {
    width: 100%;
    max-width: 504px;
  }
  .has-product {
    dl { font-size: smaller; line-height: 1.25em; margin-bottom: 0; }

    // Extra small devices get browser treatment of dd
    border-top: 1px solid #aaa;
    border-bottom: 1px solid #aaa;
    padding: 0.5em 0;
    @media (min-width: 576px) {
      border: 1px solid #aaa;
      padding: 0.5em 1em;
      // Wider devices get dt/dd side-by-side
      dl { line-height: 2em; }
      dd { display: inline; }
      dd:after { display: block; content: ''; }
      dt { width: 6em; display: inline-block; }
    }

    // Edit button appears on right
    position: relative;
    .edit-product {
      cursor: pointer;
      position: absolute;
      right: 1em;
      top: 0.8em;
      color: #aaa;
    }

    &:hover {
      border-color: #333;
      background: #f8f8f8;
      .edit-product {
        color: #333;
      }
    }
  }
  .no-product {
    border: 1px solid red;
  }
}

</style>

<script>
import {mapGetters, mapActions} from "vuex";
import TeamProductForm from './TeamProductForm';
export default {
  components: {TeamProductForm},
  props: {
    editButton: {
      type: Boolean
    }
  },
  data() {
    return {editing: false}
  },
  computed: {
    ...mapGetters(["productTemplate", "productTemplateAttrs"]),
    noCurrentProduct() {
      return !this.productTemplateAttrs;
    }
  },
  mounted() {
    this.loadProductRecs();
  },
  methods: {
    ...mapActions(['loadProductRecs']),
    toggleEditing() {
      this.editing = !this.editing;
    },
    editIcon() {
      // Work around font awesome not interacting with vue well
      return `<i class="fas fa-${this.editing ? 'times' : 'edit'}" />`
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/design/ChooseProduct.vue